import React from 'react';

import authService from '../../../utils/services/authService';
import styles from './updateProfile.module.scss';
import UserLayout from '../../../components/user-layout/UserLayout';
import DevUpdateForm from '../../../components/profile/dev-update/DevUpdateForm';
import CompUpdateForm from '../../../components/profile/company-update/CompUpdateForm';

const UpdateProfile = () => {
  const userData = authService.getUserData();
  return (
    <UserLayout>
      <section className={styles.pageWrapper}>
        {userData.role === 'developer' && <DevUpdateForm userData={userData} />}
        {userData.role === 'company' && <CompUpdateForm userData={userData} />}
      </section>
    </UserLayout>
  );
};

export default UpdateProfile;
